import React, { useState } from 'react'
import Regeneration_Orion from './Regeneration_Orion';
import styles from './EnergyPageCustom_Orion.module.css'
import Dcdc_Orion from './Dcdc_Orion';
import AUXInverterPrimary_Orion from './AUXInverterPrimary_Orion';
import AUXInverterSecondary_Orion from './AUXInverterSecondary_Orion';
import BattCoolingPrimarySecondary_Orion from './BattCoolingPrimarySecondary_Orion';
import HvacTotalDrive_Orion from './HvacTotalDrive_Orion';
import TractionSystem_Orion from './TractionSystem_Orion';

export default function Energy_Consumption_Breakdown_Orion(props) {
  let { gloablfilter } = props;
  const [defaultNav, setDefaultNav] = useState("dataRegen_kWh");

  function getNavTab(e, name) {
    setDefaultNav(name);
  }
  return (
    <>
      <div className="v-title energyTitleChart_Bus pt-2 pb-2 text-center">
        <b className=''>Energy Consumption Breakdown</b>
      </div>
      <div className="mt-1 mx-3">
        <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px" }}>
          <li className="nav-item">
            <a className="nav-link nav_in_line active" data-bs-toggle="tab" href="#Regeneration" onClick={(e) => getNavTab(e, "dataRegen_kWh")}>Regeneration</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#TractionSystem" onClick={(e) => getNavTab(e, "motorConsumption")}>TractionSystem</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#HVAC" onClick={(e) => getNavTab(e, "acConsumption")}>HVAC</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#DCDC" onClick={(e) => getNavTab(e, "dcdcLoad")}>DCDC</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#AUX_Inverter_1" onClick={(e) => getNavTab(e, "aux1Load")}>AUX-1</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#AUX_Inverter_2" onClick={(e) => getNavTab(e, "aux2Load")}>AUX-2</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#Batt_Cooling_1" onClick={(e) => getNavTab(e, "bcs1Load")}>BCS-1</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#Batt_Cooling_2" onClick={(e) => getNavTab(e, "bcs2Load")}>BCS-2</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#TcpLoad" onClick={(e) => getNavTab(e, "tcpLoad")}>TCP</a>
          </li>
        </ul>
        <div className="tab-content">
          <div id="Regeneration" className="tab-pane active">
            <div className='row'>
              <Regeneration_Orion gloablfilter={gloablfilter} modalName="Regeneration" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="TractionSystem" className="tab-pane fade">
            <div className='row'>
              <TractionSystem_Orion gloablfilter={gloablfilter} modalName="TractionSystem" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="HVAC" className="tab-pane fade">
            <div className='row'>
              <HvacTotalDrive_Orion gloablfilter={gloablfilter} modalName="HVAC" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="DCDC" className="tab-pane fade">
            <div className='row'>
              <Dcdc_Orion gloablfilter={gloablfilter} modalName="DCDC" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="AUX_Inverter_1" className="tab-pane fade">
            <div className='row'>
              <AUXInverterPrimary_Orion gloablfilter={gloablfilter} modalName="AUX_Inverter_1" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="AUX_Inverter_2" className="tab-pane fade">
            <div className='row'>
              <AUXInverterSecondary_Orion gloablfilter={gloablfilter} modalName="AUX_Inverter_2" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="Batt_Cooling_1" className="tab-pane fade">
            <div className='row'>
              <BattCoolingPrimarySecondary_Orion gloablfilter={gloablfilter} modalName="Batt_Cooling_1" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="Batt_Cooling_2" className="tab-pane fade">
            <div className='row'>
              <BattCoolingPrimarySecondary_Orion gloablfilter={gloablfilter} modalName="Batt_Cooling_2" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="TcpLoad" className="tab-pane fade">
            <div className='row'>
              <BattCoolingPrimarySecondary_Orion gloablfilter={gloablfilter} modalName="tcpLoad" itemSelected={defaultNav} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
